import React from 'react'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
const isMobile = browserCheck.isMobile

export const members = [
  {
    content: (
      <>
        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/fritz-hoffmann.png')}
              className='treeImage male family first'
            />
          </div>
          <div className='name'>
            <Link href='270453901473'>Fritz Hoffmann</Link>
          </div>
          <div className='year'>(1868–1920)</div>
        </div>

        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/adele-la-roche.png')}
              className='treeImage female family first'
            />
          </div>
          <div className='name'>
            <Link href='270453901473'>Adèle La Roche</Link>
          </div>
          <div className='year'>(1876–1938)</div>
        </div>
      </>
    ),
    id: 1,
    stage: 1,
  },
  {
    content: (
      <>
        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/emanuel-hoffmann.png')}
              className='treeImage male family'
            />
          </div>
          <div className='name'>
            <Link href='640793607445'>Emanuel Hoffmann</Link>
          </div>
          <div className='year'>(1896–1932)</div>
        </div>

        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/maja-stehlin.png')}
              className='treeImage female'
            />
          </div>
          <div className='name'>
            <Link href='896627345100'>Maja Stehlin</Link>
          </div>
          <div className='year'>(1896–1989)</div>
        </div>
      </>
    ),
    stage: 2,
    id: 2
  },
  {
    content: (
      <>
        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/anonym-male-1.png')}
              className='treeImage male family'
            />
          </div>
          <div className='name'>
            <Link href='213006539301'>Alfred Hoffmann</Link>
          </div>
          <div className='year'>(1898–1979)</div>
        </div>

        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/anonym-female-1.png')}
              className='treeImage female'
            />
          </div>
          <div className='name alone'>Alice Trobeck</div>
          {/* <div className='year'>(1897–1976)</div> */}
        </div>
      </>
    ),
    stage: 2,
    id: 3
  },
  {
    content: (
      <>
        <div className='boxWrapper one'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/paul-sacher.png')}
              className='treeImage male'
            />
          </div>
          <div className='name'>
            <Link href='477606653532'>Paul Sacher</Link>
          </div>
          <div className='year'>(1906–1999)</div>
          <div className='child'>(3 uneheliche Kinder)</div>
        </div>
      </>
    ),
    stage: 2,
    id: 4
  },
  {
    content: (
      <>
        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/lukas-hoffmann.png')}
              className='treeImage male family'
            />
          </div>
          <div className='name'>
            <Link href='466777075039'>Lukas Hoffmann</Link>
          </div>
          <div className='year'>(1923–2016)</div>
        </div>

        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/anonym-female-5.png')}
              className='treeImage female'
            />
          </div>
          <div className='name alone'>
            Daria Razumovsky
          </div>
          <div className='year'>(1925–2002)</div>
        </div>
      </>
    ),
    stage: 3,
    id: 4
  },
  {
    content: (
      <>
        <div className='boxWrapper one'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/anonym-male-2.png')}
              className='treeImage'
            />
          </div>
          <div className='name'>Andreas Hoffmann</div>
          <div className='year'>(1922–1933)</div>
        </div>
      </>
    ),
    stage: 3,
    id: 5
  },
  {
    content: (
      <>
        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/vera-hoffmann.png')}
              className='treeImage female family'
            />
          </div>
          <div className='name'>
            <Link href='951664308327'>Vera Hoffmann</Link>
          </div>
          <div className='year'>(1924–2003)</div>
        </div>

        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/jakob-oeri.png')}
              className='treeImage male'
            />
          </div>
          <div className='name alone'>
            Jakob Oeri
          </div>
          <div className='year'>(1920–2006)</div>
        </div>
      </>
    ),
    stage: 3,
    id: 6
  },
  {
    content: (
      <>
        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/vera-hoffmann-2.png')}
              className='treeImage female family'
            />
          </div>
          <div className='name'>
            <Link href='894187659257'>Vera Hoffmann</Link>
          </div>
          <div className='year'>(*1954)</div>
        </div>

        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/anonym-male-3.png')}
              className='treeImage male'
            />
          </div>
          <div className='name'>Jan Michalski</div>
          <div className='year' />
        </div>
      </>
    ),
    stage: 4,
    id: 7,
    children: (
      <>
        <ul>
          <li className='child'>Tatiana Fabre</li>
          <li className='child'>Kasia Barbotin-Larrieu</li>
        </ul>
      </>
    )
  },
  {
    content: (
      <>
        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/maja-hoffmann.png')}
              className='treeImage female family'
            />
          </div>
          <div className='name'>
            <Link href='278308216419'>Maja Hoffmann</Link>
          </div>
          <div className='year'>(*1956)</div>
        </div>

        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/anonym-male-4.png')}
              className='treeImage male'
            />
          </div>
          <div className='name'>Stanley Buchthal</div>
          <div className='year' />
        </div>
      </>
    ),
    stage: 4,
    id: 8,
    children: (
      <>
        <ul>
          <li className='child'>Lucas Hoffmann</li>
          <li className='child'>Marina Hoffmann</li>
        </ul>
      </>
    )
  },
  {
    content: (
      <>
        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/andre-hoffmann.png')}
              className='treeImage male family'
            />
          </div>
          <div className='name'>
            <Link href='608744256313'>André Hoffmann</Link>
          </div>
          <div className='year'>(*1958)</div>
        </div>

        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/anonym-female-2.png')}
              className='treeImage female'
            />
          </div>
          <div className='name'>
            Rosalie
            Coombe-<br />Tennant
          </div>
          <div className='year' />
        </div>
      </>
    ),
    stage: 4,
    id: 9,

    children: (
      <>
        <ul>
          <li className='child'>Alexander Hoffmann</li>
          <li className='child'>Frederic Hoffmann</li>
          <li className='child'>Isabel Hoffmann</li>
        </ul>
      </>
    )
  },
  {
    content: (
      <>
        <div className='boxWrapper one'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/anonym-female-3.png')}
              className='treeImage female family'
            />
          </div>
          <div className='name'>
            Daschenka Hoffmann
          </div>
          <div className='year'>(1954–2019)</div>
        </div>
      </>
    ),
    name: 'Daschenka Hoffmann',
    stage: 4,
    id: 10
  },
  {
    content: (
      <>
        <div className='boxWrapper' style={{ minWidth: '150px' }}>
          <div className='imageContainer'>
            <Image
              file={require('../../images/maja-oeri.png')}
              className='treeImage female family'
            />
          </div>
          <div className='name'>
            <Link href='896217865159'>Maja Oeri</Link>
          </div>
          <div className='year'>(*1955)</div>
        </div>

        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/hans-bodenmann.png')}
              className='treeImage male'
            />
          </div>
          <div className='name'>
            <Link href='968725507413'>Hans U. Bodenmann</Link>
          </div>
          <div className='year'>(1926–2016)</div>
        </div>
      </>
    ),
    stage: 4,
    id: 11,
    children: (
      <>
        <ul style={{ paddingLeft: '7.6em' }}>
          <li className='child'>Hans Emanuel Oeri (*1992)</li>
          <li className='child'>Melchior Oeri (*1994)</li>
        </ul>
      </>
    )
  },
  {
    content: (
      <>
        <div className='boxWrapper one'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/beatrice-oeri.png')}
              className='treeImage female family'
            />
          </div>
          <div className='name'>
            <Link href='505458363131'>Beatrice Oeri</Link>
          </div>
          <div className='year'>(*1954)</div>
        </div>
      </>
    ),
    stage: 4,
    id: 12
  },
  {
    content: (
      <>
        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/catherine-oeri.png')}
              className='treeImage female family'
            />
          </div>
          <div className='name'>
            <Link href='813339955333'>Catherine Oeri</Link>
          </div>
          <div className='year'>(*1951)</div>
        </div>

        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/michael-kessler.png')}
              className='treeImage male'
            />
          </div>
          <div className='name'>
            <Link href='455771342212'>Michael Kessler</Link>
          </div>
          <div className='year'>(1958–2018)</div>
        </div>
      </>
    ),
    stage: 4,
    id: 13
  },
  {
    content: (
      <>
        <div className='boxWrapper' style={{ minWidth: '130px' }}>
          <div className='imageContainer'>
            <Image
              file={require('../../images/sabine-oeri.png')}
              className='treeImage female family'
            />
          </div>
          <div className='name'>
            <Link href='580917010083'>Sabine Oeri</Link>
          </div>
          <div className='year'>(*1950)</div>
        </div>

        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/anonym-male-5.png')}
              className='treeImage male'
            />
          </div>
          <div className='name alone'>
            Hansjörg Duschmalé
          </div>
          <div className='year'>(1939–2017)</div>
        </div>
      </>
    ),
    stage: 4,
    id: 14,
    children: (
      <>
        <ul style={{ paddingLeft: '4.5em' }}>
          <li className='child'>Jörg Duschmalé (*1984)</li>
          <li className='child'>Lukas&nbsp;Duschmalé (*1985)</li>
        </ul>
      </>
    )
  },
  {
    content: (
      <>
        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/andreas-oeri.png')}
              className='treeImage male family'
            />
          </div>
          <div className='name'>
            <Link href='833355895066'>Andreas Oeri</Link>
          </div>
          <div className='year'>(*1949)</div>
        </div>

        <div className='boxWrapper'>
          <div className='imageContainer'>
            <Image
              file={require('../../images/gisela-trefzer.png')}
              className='treeImage female'
            />
          </div>
          <div className='name'>
            <Link href='430965891965'>Gisela Trefzer</Link>
          </div>
          <div className='year'>(*1955)</div>
        </div>
      </>
    ),
    stage: 4,
    id: 15
  }
]
